'use strict';

var _ = require('lodash');
var PooledSeasonalityReviewToolbarController = function PooledSeasonalityReviewToolbarController($scope) {
  $scope.cogValue = 'pooled-seasonality-review-toolbar';
  $scope.cogOptionsSet = _.clone(require('../config/cogOptionsSet.json'));
  $scope.cogOptionsSet.defaults = {
    'no-submenu': {
      'no-group': [$scope.screenState.flowType.toLowerCase()]
    }
  };
  $scope.flowTypeChange = function (event, data) {
    $scope.screenState.flowType = _.capitalize(data.val[0]);
  };
};
PooledSeasonalityReviewToolbarController.$inject = ['$scope'];
module.exports = PooledSeasonalityReviewToolbarController;